import React, { useEffect, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  addDonor,
  editDonor,
  setSelectedDonor,
} from "../../features/donorsSlice";
import { closeModal } from "../../features/modalSLice";
import AddResource from "../../components/header/AddResource";
import InputField from "../../components/form/InputField";
import SelectField from "../../components/form/SelectField";
import { getCountries, unsetCountries } from "../../features/countriesSlice";
import Loading from "../../components/loading/Loading";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import PhoneInputField from "../../components/form/PhoneInputField";
import { useNotification } from "../../components/notification/NotificationContainer";
import { zodResolver } from "@hookform/resolvers/zod";
import { addDepartmentSchema, addDonorSchema } from "../../schemas";
import {
  addDepartment,
  editDepartment,
  setSelectedDepartment,
} from "../../features/departmentSlice";
import loadStatus from "../../util/loadStatus";

const AddDepartment = ({ edit, id }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userInfo);
  const department = useSelector((state) => state.departments.selected);
  const departmentLoad = useSelector(
    (state) => state.departments.load.getDepartment
  );
  const addDepartmentLoad = useSelector(
    (state) => state.departments.load.addDepartment
  );
  const editDepartmentLoad = useSelector(
    (state) => state.departments.load.editDepartment
  );
  const addNotification = useNotification();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: zodResolver(addDepartmentSchema) });

  const onSubmit = async (data, e) => {
    e.preventDefault();
    try {
      if (edit) {
        const res = await dispatch(editDepartment({ id, reqData: data }));
        if (editDepartment.fulfilled.match(res)) {
          dispatch(closeModal());
          dispatch(setSelectedDepartment(res.payload));
          addNotification("Department updated successfully!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      } else {
        const res = await dispatch(addDepartment(data));
        if (addDepartment.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Department added successfully!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  useEffect(() => {
    if (department.id) {
      reset({
        province_id: department.province_id,
        name: department.name,
        slug: department.slug,
      });
    } else {
      if (user.id) {
        reset({ province_id: user.province_id });
      }
    }
  }, [department, user]);

  if (departmentLoad === loadStatus.loading && edit) {
    return (
      <div className="min-w-72 sm:min-w-96 w-full h-96">
        <Loading />
      </div>
    );
  }

  return (
    <div className="min-w-72 sm:min-w-[30rem] w-full">
      <AddResource title={edit ? "Edit Department" : "Add Department"} />
      <form
        autoComplete="off"
        autoCorrect="off"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex flex-col justify-center items-center gap-2 w-full">
          <InputField
            register={register}
            type="text"
            autoComplete="off"
            name="name"
            label="Name"
            errors={errors.name}
          />

          <InputField
            register={register}
            type="text"
            autoComplete="off"
            name="slug"
            label="Slug"
            errors={errors.slug}
          />

          <InputField
            register={register}
            type="hidden"
            autoComplete="off"
            name="province_id"
            defaultValue={user.province_id}
          />
        </div>
        <ResourseButtons loading={addDepartmentLoad || editDepartmentLoad} />
      </form>
    </div>
  );
};

export default AddDepartment;
